import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
// .. Link root api
const API_ROOT_URL = environment.ApiRoot + '/dashboard';
// ................
@Injectable()
export class DashboardExpiryService {
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getData(productTypes: number[] = [], products: number[] = [], outOfDate: number = 1): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/DashBoardExpiry`;
		let params = new HttpParams();
		productTypes.forEach(type => {
		  	params = params.append('productTypes', type.toString());
		});
		products.forEach(type => {
			params = params.append('products', type.toString());
		});
		params = params.append('outOfDate', outOfDate.toString());
		return this.http.get<any>(url,
		{
			headers: httpHeaders,
			params: params
		});
	}

	exportDashboardExpiry(
		productTypes: number[] = [],
		products: number[] = [],
		outOfDate: number = 1,
		productCode: string = "",
		productName: string = "",
		unitName: string = "",
		lot: string = "",
		productionDateMin: string = "",
		productionDateMax: string = "",
		expirationDateMin: string = "",
		expirationDateMax: string = ""
	) : Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		let params = new HttpParams();
		productTypes.forEach(type => {params = params.append('productTypes', type.toString());});
		products.forEach(type => {params = params.append('products', type.toString());});
		params = params.append('outOfDate', outOfDate.toString());
		params = params.append('productCode', productCode.toString());
		params = params.append('productName', productName.toString());
		params = params.append('unitName', unitName.toString());
		params = params.append('lot', lot.toString());
		params = params.append('productionDateMin', productionDateMin.toString());
		params = params.append('productionDateMax', productionDateMax.toString());
		params = params.append('expirationDateMin', expirationDateMin.toString());
		params = params.append('expirationDateMax', expirationDateMax.toString());
		return this.http.get<Blob>(API_ROOT_URL + '/export_dashboard_expiry', {
			headers: httpHeaders,
			params: params,
			responseType: 'blob' as 'json'
		});
	}
}
